module.exports = __webpack_public_path__ + "img/globe-mana.4c7e85a2.png";